// サイト情報
/** コーポレートサイト */
export const CORPORATE_SITEURL = 'https://www.plan-b.co.jp';

/** サイト名 */
export const SITENAME = process.env.VUE_APP_SITENAME;

/** インフルエンサー APP */
export const APP_LOGIN_SITEURL = process.env.VUE_APP_LOGIN_SITEURL;

/** インフルエンサー モールログイン */
export const APP_FRONT_SITEURL = process.env.VUE_APP_FRONT_SITEURL;
